import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {FullCalendarModule } from '@fullcalendar/angular';
import {Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { StorageService } from './services/storage.service';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Storage } from '@ionic/storage-angular';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'portfolio-app' }),
    IonicModule.forRoot(),
    AppRoutingModule,
    FullCalendarModule
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, 
    Deeplinks,
    StorageService,
    StatusBar,
    Storage
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
